export default __webpack_public_path__ + "static/media/linkdn-icon.f5ff6ef9.svg";